export default __webpack_public_path__ + "static/media/techresourcesandperspectives.04ddda39.svg";